module.exports = __webpack_public_path__ + "static/media/AllYouHavetoDo_Bookcover.d4255ae3.jpg";